import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { StatusChip } from "shared";
import { SxProps } from "@mui/material/styles";
import { InputBaseComponentProps } from "@mui/material";

const statuses = [
  {
    id: "Нужно сделать",
    color: "#787977",
    name: "Нужно сделать",
  },
  {
    id: "В работе",
    color: "#CFA100",
    name: "В работе",
  },
  {
    id: "Выполнено",
    color: "#88E181",
    name: "Выполнено",
  },
];

export const S4sStatusSelect = ({
  sx,
  error,
  helperText,
  inputProps,
  value,
  onChange,
}: {
  sx?: SxProps;
  error?: boolean;
  helperText?: string;
  inputProps?: InputBaseComponentProps;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}) => {
  return (
    <TextField
      onChange={onChange}
      value={value}
      error={error}
      helperText={helperText}
      inputProps={inputProps}
      sx={{ minWidth: 200, ...sx }}
      fullWidth
      label="Статус с4с"
      select
      size="small"
      defaultValue=""
    >
      <MenuItem value="">
        <em>Выберите статус</em>
      </MenuItem>
      {statuses.map((status) => (
        <MenuItem key={status.id} value={status.id}>
          <StatusChip title={status.name} color={status.color} />
        </MenuItem>
      ))}
    </TextField>
  );
};
